"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_search-posts-list.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function SearchPostsList(_ref) {
  var history = _ref.history,
      onFiltersChange = _ref.onFiltersChange,
      renderCardItem = _ref.renderCardItem,
      posts = _ref.posts,
      loading = _ref.loading,
      filterOptions = _ref.filterOptions;
  return _react.default.createElement("div", {
    className: "search-posts-list"
  }, _react.default.createElement(_uiKit.List, {
    history: history,
    renderCardItem: renderCardItem,
    onFiltersChange: onFiltersChange,
    data: posts,
    emptyDataText: _react.default.createElement("p", {
      className: "search-posts-list__empty"
    }, 'There aren\'t any Inspirations that match this search.'),
    filters: filterOptions,
    loading: loading,
    listKey: "inspirationId",
    filtersRightAddon: _react.default.createElement("h4", null, "Results Found (".concat(posts.length, ")"))
  }));
}

var _default = (0, _react.memo)(SearchPostsList);

exports.default = _default;